module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('profile.password.title')
    }
  }, [_c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "info": "",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.$t('changePasswordDescription')))]), _vm._v(" "), _c('password-form', {
    attrs: {
      "error": _vm.error
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adcab0c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PasswordChange.vue
// module id = 1095
// module chunks = 1